<template>
<div  v-loading="loading" element-loading-text="数据导出中">
  <div class="op">
    <Candode v-on:childByValue="childByValue" v-on:getTownlength="getTownlength"></Candode>
<div class="nam">
  <el-input v-model="name" style="margin-left:10px" clearable size="mini" placeholder="请输入姓名"></el-input>
</div>
  <div class="idc">
  <el-input v-model="idcard" @change="toup" size="mini" clearable placeholder="请输入身份证号"></el-input>
</div>
<div class="add">
    <el-date-picker
      v-model="time"
      size='mini'
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
</div>
 <div class="add"  style="margin-left:10px">
  <el-select size="mini"  v-model="isNew" placeholder="数据来源">
    <el-option
      v-for="item6 in isNewList"
      :key="item6.value"
      :label="item6.label"
      :value="item6.value">
    </el-option>
  </el-select>
</div>
</div>
<div class="op" style="margin-top:10px">
   <div class="add"  style="margin-left:0">
  <el-select size="mini" @change="torz"  v-model="cblx" placeholder="补贴类型">
    <el-option
      v-for="item6 in cblxList"
      :key="item6.value"
      :label="item6.label"
      :value="item6.value">
    </el-option>
  </el-select>
</div>
<div class="add">
    <el-select size="mini" @change="torz" clearable v-model="age" placeholder="选择年龄">
    <el-option
      v-for="item4 in ageList"
      :key="item4.value"
      :label="item4.label"
      :value="item4.value">
    </el-option>
  </el-select>
</div>
<div class="add">
    <el-select size="mini" @change="torz" clearable v-model="agemeth" placeholder="年龄计算方式">
    <el-option
      v-for="item5 in agemethList"
      :key="item5.value"
      :label="item5.label"
      :value="item5.value">
    </el-option>
  </el-select>
</div>
<div class="add">
    <el-select size="mini"  clearable @change="ownStateChange" v-model="ownState" placeholder="个人状态">
    <el-option
      v-for="item5 in ownStateList"
      :key="item5.value"
      :label="item5.label"
      :value="item5.value">
    </el-option>
  </el-select>
</div>
<div class="add">
    <el-date-picker
      v-model="dietime"
      size='mini'
      v-show="isdietime"
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
</div>
<div class="add">
    <el-select size="mini" @change="qctimechange"  clearable v-model="authStates" placeholder="补贴状态">
    <el-option
      v-for="item5 in authStatesList"
      :key="item5.value"
      :label="item5.label"
      :value="item5.value">
    </el-option>
  </el-select>
</div>
<div class="add">
    <el-date-picker
      v-model="qctime"
      size='mini'
      v-show="isqctime"
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
</div>
<el-button type="primary" size="mini" style="background:#148A9B;margin-left:10px" icon="el-icon-search" @click="serch">搜索</el-button>
</div>
  <el-table
    :data="tableData"
    style="width: 100%"
    stripe>
     <el-table-column
      label="身份证号"
      width="180">
      <template slot-scope="scope">
      <span style="color:#27ADF8;cursor:pointer;border-bottom:1px solid #27ADF8" @click="toOwm(scope.row.identityNumber)"> {{ scope.row.identityNumber }}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="personName"
      label="姓名"
      width="100">
    </el-table-column>
     <el-table-column
      prop="telphone"
       width="110"
      label="手机号">
    </el-table-column>
    <el-table-column
      prop="bankNo"
       width="180"
      label="银行卡号">
    </el-table-column>
     <el-table-column
      prop="bankType"
      label="银行名称">
    </el-table-column>
      <el-table-column
      prop="verify_type"
       width="100"
      label="补贴类型">
    </el-table-column>
    <el-table-column
      prop="data_state"
       width="100"
      label="个人状态">
    </el-table-column>
    <el-table-column
      prop="adrState"
       width="100"
      label="补贴状态">
    </el-table-column>

     <el-table-column
      prop="nowAddress"
      label="所在地区">
    </el-table-column>
     <el-table-column
      label="数据来源"
      width="180">
      <template slot-scope="scope">
        {{scope.row.isNew==0?"导入":scope.row.isNew==1?"后台新增":scope.row.isNew==2?"APP登记录入":"未知"}}
      </template>
    </el-table-column>
    <el-table-column
      prop="createTime"
      label="采集时间">
    </el-table-column>
     <el-table-column
      prop="createtime"
      label="采集照片">
      <template slot-scope="scope">
        <el-popover
    placement="left"
    title=""
    trigger="hover">
                    <img slot="reference" :src="(scope.row.defaultPhoto?(imgUrl+scope.row.defaultPhoto):'')||defaultImg" height="70"  class="head_pic">
                    <img :src="(scope.row.defaultPhoto?(imgUrl+scope.row.defaultPhoto):'')||defaultImg"  height="200px"  class="head_pic"/>
                    </el-popover>
                </template>
    </el-table-column>

  </el-table>
  <ageList v-on:ageListEvent="ageListEvent" />
  <div class="rrr">
  <el-pagination
  	class="pone"
      :page-size='10'
      layout="total, prev, pager, next, jumper"
      :total="totals"
      :current-page.sync="Page"
      @current-change="current_change"
>
    </el-pagination>
    <!-- <el-button type="success" size="mini" icon="el-icon-download" @click="toExcel()">导出</el-button> -->
     <kt-button class="changeBasic" icon="fa el-icon-download" label="导出" perms="auth:menu:down" type="primary" @click="toExcel" />
    </div>
  </div>
</template>

<style scoped>
.rrr {
  display: flex;
  margin: 20px;
  height: 30px;
  justify-content: space-around;
  align-items: center;
}
.pone {
  margin: 0 !important;
}
.el-cascader-menu__wrap {
  height: 404px !important;
}
.op {
  display: flex;
  align-items: center;
}
.idc {
  width: 200px;
}
.nam {
  margin-right: 20px;
}
.ywtyoe {
  width: 200px;
  margin-left: 20px;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}

.el-timeline {
  padding-left: 20px;
}
.add {
  margin-left: 20px;
}
</style>

<script>
import Axios from "axios";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import { Loading } from "element-ui";
import { listtown } from "../../utils/address";
import { baseUrl2 } from "../../utils/global";
import defaultImg from "../../assets/defaultPicture.jpg";
import Candode from "../Core/candode";
import { decryptByDES, decrypt } from "../../utils/cypto";
import { formatDate } from "../../utils/datetime";
import { getType } from "../../utils/typeAuth";
import baseUrl from "../../utils/global";
import KtButton from "@/views/Core/KtButton";
import { fromModel } from "../../utils/fromModel";
import ageList from "../../utils/ageList.vue";
export default {
  components: {
    Candode,
    KtButton,
    ageList
  },
  data() {
    return {
      authStates: "",
      authStatesList: [
        {
          label: "正常",
          value: 0
        },
        {
          label: "待遇停发",
          value: 4
        },
        {
          label: "户籍迁出",
          value: -1
        }
      ],
      qctime: "",
      isqctime: false,
      ownState: "",
      ownStateList: [
        {
          label: "正常",
          value: 0
        },
        {
          label: "已死亡",
          value: 5
        }
      ],
      loading: false,
      list: [],
      name: "",
      isdietime: false,
      dietime: "",
      town: "",
      village: "",
      defaultImg: defaultImg,
      townList: [],
      imgUrl: "http://socialsecurity-storage.oss-cn-beijing.aliyuncs.com/",
      Page: 1,
      totals: 0,
      idcard: "",
      info: "",
      ywtype: "",
      tableData: [],
      list2: [],
      //认证状态
      state: "",
      stateList: [
        {
          value: "0",
          label: "认证成功"
        },
        {
          value: "2",
          label: "认证失败"
        },
        {
          value: "5",
          label: "未认证"
        },
        {
          value: "3",
          label: "审核中"
        }
      ],
      //时间
      time: "",
      isNew: "",
      isNewList: [
        {
          value: "0",
          label: "导入"
        },
        {
          value: "1",
          label: "后台新增"
        },
        {
          value: "2",
          label: "APP登记录入"
        }
      ],
      //年龄
      age: "",
      ageList: "",
      //年龄计算方式
      agemeth: "1",
      agemethList: [
        {
          value: "1",
          label: "按年计算"
        },
        {
          value: "2",
          label: "按月计算"
        }
      ],
      //补贴类型
      cblx: "",
      cblxList: [],
      townlen: 1
    };
  },
  methods: {
    ownStateChange() {
      if (this.ownState == 5) {
        this.isdietime = true;
      } else {
        this.isdietime = false;
        this.dietime = "";
      }
    },
    qctimechange() {
      if (this.authStates == "-1") {
        this.isqctime = true;
      } else {
        this.isqctime = false;
        this.dietime = "";
      }
    },
    toOwm(s) {
      this.$router.push({
        name: "个人信息",
        params: {
          idcard: s
        }
      });
    },
    toup() {
      this.idcard = this.idcard.toUpperCase();
    },
    fromModel: fromModel,
    strReplace(msg) {
      let str = getType(msg);
      return str;
    },
    formatDate: formatDate,
    childByValue(val) {
      this.townList = val;
      // this.serchCode()
    },
    getTownlength(val) {
      this.townlen = val;
    },
    //搜索
    serch() {
      // const isTown = this.townList[2] ? this.townList[2].split(",")[0] : "";
      // if (!isTown) {
      //   this.$message({
      //     type: "warning",
      //     message: "请选择县/区及以下区域进行操作"
      //   });
      //   return;
      // }
      this.serchTest(1);
    },
    ageListEvent(s) {
      this.ageList = s;
    },
    serchCode() {
      let data = {
        pageNum: 1,
        pageSize: 10,
        personName: this.name ? this.Encrypt(this.name) : "",
        provinceName: this.townList[0] ? this.townList[0].split(",")[1] : "",
        cityName: this.townList[1] ? this.townList[1].split(",")[1] : "",
        countryName: this.townList[2] ? this.townList[2].split(",")[1] : "",
        townName: this.townList[3] ? this.townList[3].split(",")[1] : "",
        groupName: this.townList[5] ? this.townList[5].split(",")[1] : "",
        villageName: this.townList[4] ? this.townList[4].split(",")[1] : "",
        birthday: this.age,
        identityNumber: this.idcard ? this.Encrypt(this.idcard) : "",
        verify_type: this.cblx,
        startTime: this.time ? this.formatDate(this.time[0]) : "",
        endTime: this.time ? this.formatDate(this.time[1]) : "",
        updateLibStartTime: this.dietime
          ? this.formatDate(this.dietime[0])
          : "",
        updateLibEndTime: this.dietime ? this.formatDate(this.dietime[1]) : "",
        updateAdrStartTime: this.qctime ? this.formatDate(this.qctime[0]) : "",
        updateAdrEndTime: this.qctime ? this.formatDate(this.qctime[1]) : "",
        quarry_rule: this.agemeth,
        data_state: this.ownState,
        adrState: this.authStates,
        isNew: this.isNew
      };
      this.$api.getlist
        .findVerifyPage(data)
        .then(res => {
          let result = res.data.list;
          this.totals = res.data.total;
          for (var i in result) {
            result[i].identityNumber = this.decrypt(result[i].identityNumber);
            result[i].personName = this.decrypt(result[i].personName);
            result[i].telphone = result[i].telphone
              ? this.decrypt(result[i].telphone)
              : "";
            result[i].createTime = result[i].createTime
              ? this.formatDate(result[i].createTime)
              : "";
            result[i].verify_type = result[i].verify_type
              ? this.strReplace(result[i].verify_type)
              : "";
            result[i].data_state =
              result[i].data_state == 0
                ? "正常"
                : result[i].data_state == 4
                  ? "待遇停发"
                  : result[i].data_state == 5
                    ? result[i].updateStateTime
                      ? "死亡(" +
                        this.formatDate(result[i].updateStateTime) +
                        ")"
                      : "死亡"
                    : "";
            result[i].adrState =
              result[i].adrState == 0
                ? "正常"
                : result[i].adrState == 4
                  ? "待遇停发"
                  : "";
            result[i].nowAddress =
              result[i].provinceName +
              result[i].cityName +
              result[i].countryName +
              result[i].townName +
              (result[i].villageName ? result[i].villageName : "") +
              (result[i].groupName ? result[i].groupName : "");
          }
          this.tableData = result;
        })
        .catch(res => {
          this.$message(JSON.stringify(res));
        });
    },
    toExcel() {
      // const isTown = this.townList[2] ? this.townList[2].split(",")[0] : "";
      // if (!isTown) {
      //   this.$message({
      //     type: "warning",
      //     message: "请选择县/区及以下区域进行操作"
      //   });
      //   return;
      // }
      this.loading = true;
      let data = {
        personName: this.name ? this.Encrypt(this.name) : "",
        provinceName: this.townList[0] ? this.townList[0].split(",")[1] : "",
        cityName: this.townList[1] ? this.townList[1].split(",")[1] : "",
        countryName: this.townList[2] ? this.townList[2].split(",")[1] : "",
        townName: this.townList[3] ? this.townList[3].split(",")[1] : "",
        groupName: this.townList[5] ? this.townList[5].split(",")[1] : "",
        villageName: this.townList[4] ? this.townList[4].split(",")[1] : "",
        birthday: this.age,
        identityNumber: this.idcard ? this.Encrypt(this.idcard) : "",
        isNew: this.isNew,
        verify_type: this.cblx,
        startTime: this.time ? this.formatDate(this.time[0]) : "",
        endTime: this.time ? this.formatDate(this.time[1]) : "",
        updateLibStartTime: this.dietime
          ? this.formatDate(this.dietime[0])
          : "",
        updateLibEndTime: this.dietime ? this.formatDate(this.dietime[1]) : "",
        updateAdrStartTime: this.qctime ? this.formatDate(this.qctime[0]) : "",
        updateAdrEndTime: this.qctime ? this.formatDate(this.qctime[1]) : "",
        quarry_rule: this.agemeth,
        data_state: this.ownState,
        adrState: this.authStates
      };
      this.$api.getlist
        .downColData(data)
        .then(res => {
          var that = this;
          if (res.code == 200) {
            this.loading = false;
            window.location.href =
              baseUrl.baseUrl + "/download/excel?fileName=" + res.result;
          } else {
            this.loading = false;
            this.$message(res.describe);
          }
        })
        .catch(res => {
          this.$message("导出失败");
          this.loading = false;
        });
    },
    serchTest(s) {
      Loading.service();
      console.log(this.townList);
      var data = {
        pageNum: s,
        pageSize: 10,
        personName: this.name ? this.Encrypt(this.name) : "",
        provinceName: this.townList[0] ? this.townList[0].split(",")[1] : "",
        cityName: this.townList[1] ? this.townList[1].split(",")[1] : "",
        countryName: this.townList[2] ? this.townList[2].split(",")[1] : "",
        townName: this.townList[3] ? this.townList[3].split(",")[1] : "",
        villageName: this.townList[4] ? this.townList[4].split(",")[1] : "",
        groupName: this.townList[5] ? this.townList[5].split(",")[1] : "",
        birthday: this.age,
        isNew: this.isNew,
        identityNumber: this.idcard ? this.Encrypt(this.idcard) : "",
        verify_type: this.cblx,
        startTime: this.time ? this.formatDate(this.time[0]) : "",
        endTime: this.time ? this.formatDate(this.time[1]) : "",
        updateLibStartTime: this.dietime
          ? this.formatDate(this.dietime[0])
          : "",
        updateLibEndTime: this.dietime ? this.formatDate(this.dietime[1]) : "",
        updateAdrStartTime: this.qctime ? this.formatDate(this.qctime[0]) : "",
        updateAdrEndTime: this.qctime ? this.formatDate(this.qctime[1]) : "",
        quarry_rule: this.agemeth,
        data_state: this.ownState,
        adrState: this.authStates
      };
      this.$api.getlist
        .queryPersonAll(data)
        .then(res => {
          let result = res.data.list;
          this.totals = res.data.total;
          for (var i in result) {
            result[i].identityNumber = this.decrypt(result[i].identityNumber);
            result[i].personName = this.decrypt(result[i].personName);
            result[i].telphone = result[i].telphone
              ? this.decrypt(result[i].telphone)
              : "";
            result[i].createTime = result[i].createTime
              ? this.formatDate(result[i].createTime)
              : "";
            result[i].verify_type = result[i].verify_type
              ? this.strReplace(result[i].verify_type)
              : "";
            result[i].data_state =
              result[i].data_state == 0
                ? "正常"
                : result[i].data_state == 4
                  ? "待遇停发"
                  : result[i].data_state == 5
                    ? result[i].updateStateTime
                      ? "死亡(" +
                        this.formatDate(result[i].updateStateTime) +
                        ")"
                      : "死亡"
                    : "";
            result[i].adrState =
              result[i].adrState == 0
                ? "正常"
                : result[i].adrState == 4
                  ? "待遇停发"
                  : result[i].adrState == -1
                    ? result[i].updatetime
                      ? "户籍迁出(" +
                        this.formatDate(result[i].updatetime) +
                        ")"
                      : "户籍迁出"
                    : "";
            result[i].nowAddress =
              result[i].provinceName +
              result[i].cityName +
              result[i].countryName +
              (result[i].townName ? result[i].townName : "") +
              (result[i].villageName ? result[i].villageName : "") +
              (result[i].groupName ? result[i].groupName : "");
          }
          this.tableData = result;
          let loadingInstance = Loading.service();
          this.$nextTick(() => {
            //以服务的方式调用的 Loading需要异步关闭
            loadingInstance.close();
          });
        })
        .catch(err => {
          let loadingInstance = Loading.service();
          this.$nextTick(() => {
            //以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close();
          });
        });
    },
    current_change(ss) {
      this.serchTest(ss);
    },
    handleChange() {},
    torz() {},
    //查看
    handle(s, d) {},
    handleDelete(g, h) {
      console.log(g);
      console.log(h);
    },
    Encrypt(word) {
      //aes加密
      var key = CryptoJS.enc.Utf8.parse("abcdtnfo23255625");
      let srcs = CryptoJS.enc.Utf8.parse(word);
      let encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },
    decrypt(word) {
      var key = CryptoJS.enc.Utf8.parse("abcdtnfo23255625");
      var decrypt = CryptoJS.AES.decrypt(word, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return CryptoJS.enc.Utf8.stringify(decrypt).toString();
    },
    decryptDes(message) {
      var keyHex = CryptoJS.enc.Utf8.parse("abcdtnfo23255625");
      var decrypted = CryptoJS.DES.decrypt(
        {
          ciphertext: CryptoJS.enc.Hex.parse(message)
        },
        keyHex,
        {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        }
      );
      return decrypted.toString(CryptoJS.enc.Utf8);
    }
  },

  created() {
    let arr;
    if (sessionStorage.getItem("typeControll") == "null") {
      arr = JSON.parse(sessionStorage.getItem("codes"));
    } else {
      arr = JSON.parse(sessionStorage.getItem("typeControll"));
      arr.unshift("");
    }

    for (let i in arr) {
      this.cblxList.push({
        label: getType(arr[i]),
        value: arr[i]
      });
    }
    this.cblx = arr[0];
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Myvue/personInfo.vue